import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function ArticleSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-18">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">最新资讯</h2>
            <p className="text-sm text-foreground-500 mt-1.5">影视动态、观影指南，一手掌握</p>
          </div>
          <Link
            to="/category?tab=articles"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group cursor-pointer bg-white rounded-xl overflow-hidden hover:bg-background-50 transition-colors"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2.5">
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category?tab=articles"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}